import React, { Component }  from 'react';
import {connect}             from 'react-redux';
import moment                from 'moment';
import $                     from 'jquery';
import {Link}                from 'react-router-dom';
import AcaoMissao            from './missao_acao';
import RenderHeader          from '../../../container/renderHeader';
import FlashCarregando       from '../../../container/FlashCarregando';
import { GetTarefa }         from '../../../actions/tarefaAction';
import {GetTipoMidiaPost}    from '../../../actions/grupoAction';
import { SetError }          from '../../../actions/authenticActions';
import svg6 from '../../../img/quest_box/animation/step6.svg'
import "../../../css/aluno/quest_box.css";

class missao_concluir extends Component {

    constructor(props){
            super(props)
             this.state = {
                            showModal               : false,
                            acao                    : false,
                            file                    : null,
                            tar_tar_descricao       : "",
                            tar_data_entrega        : "",
                            tar_cod_equipe          : 0,
                            tar_id                  : this.props.match.params.id,
                            dados              :[],
                            load:false
                         }
    }    

    componentWillMount() {
        this.props.GetTarefa(this.props.session.id,this.state.tar_id).then((response)=>{

            this.setState({dados:response.data,load:true});
        })
    }
   
    renderAnimacao(){

            var index = 0;
            var $questBoxAnimation = $(".quest-box-animation");
        
            var $animationFrames = $questBoxAnimation.children();
        
            function Previous(){
                var $previous = $questBoxAnimation.children(".previous");
                if($previous.length === 0){
                    $previous = $animationFrames.eq(0).toggleClass("previous",true);
                }
        
                return $previous;
            }
        
            function Current(){
                var $current = $questBoxAnimation.children(".current");
                if($current.length === 0){
                    $current = $animationFrames.eq(0).toggleClass("current",true);
                }
                return $current;
            }
        
            Previous()
                .toggleClass("previous",false)
                .toggleClass("current",false)
            ;
        
            Current()
                .toggleClass("current",false)
                .toggleClass("previous",true)
            ;
        
            setInterval(function(){
                index = (index+1)%($animationFrames.length);
        
                Previous()
                    .animate({
                        "opacity": 0
                    },1000,function(){
                        $(this)
                            .toggleClass("previous",false)
                            .toggleClass("current",false)
                            .css("opacity","")
                        ;
                    })
                ;
        
                Current()
                    .toggleClass("current",false)
                    .toggleClass("previous",true)
                ;
        
               //$current = $animationFrames.eq(index);
               $animationFrames.eq(index).toggleClass("current",true)
                ;
            },2000);
                   
    }

    renderMidia(){

        if (this.state.dados.tar_tipo_midia === 1) {
            return this.props.GetTipoMidiaPost({equ_pos_tipo:2,equ_pos_midia:this.state.dados.tar_midia})
        } else {
            return this.props.GetTipoMidiaPost({equ_pos_tipo:3,equ_pos_midia:this.state.dados.tar_midia})
        }
    }
     
    render() {

        this.renderAnimacao();

        const width1 = {width:'25%'}
        const width2 = {width:'71%'}

        return (
            <div className="hud-middle-center active">



             <RenderHeader titulo="Missões"/>


<main className="hud-middle-center-content">

{!this.state.load ? <FlashCarregando/> :
                    <div className="quest-box quest-box-standard">
                        <div className="quest-box-header">
                            <div className="quest-box-header-decoration"></div>
                            <div className="quest-box-header-info">
                                <div className="quest-box-header-info-meta">
                                    até {moment(this.state.dados.tar_data_fim).format("DD/MM/YYYY")}
                                </div>
                                <div className="quest-box-header-info-tools">
                                    <Link to={this.props.menu.missao.home} className="simple-action">&times;</Link>
                                </div>
                            </div>
                        </div>
                        <div className="quest-box-body">
                            <div className="quest-box-row">
                                <div className="quest-box-column">
                                    <div className="quest-box-title-alternative">
                                        {this.state.dados.tar_titulo}
                                    </div>
                                    <div className="quest-box-text">
                                       {this.state.dados.tar_descricao}
                                    </div>
                                </div>
                                {this.state.dados.tar_tipo_midia>0 ?
                                <div className="quest-box-column" dangerouslySetInnerHTML={{__html: this.renderMidia()}} >
                                  
                                </div>
                                :
                                ""
                                }
                            </div>
                            <div className="quest-box-row">
                                <div className="quest-box-column quest-box-column-borderless">
                                    <div className="quest-box-row">
                                        <div className="quest-box-column">
                                            <div className="quest-box-title">Objetivo</div>
                                            <div className="quest-box-text">
                                            {this.state.dados.tar_objetivo}
                                            </div>
                                        </div>
                                
                                    </div>
                                </div>

                                    {this.state.dados.tar_anexo ? 
                                    <div className="quest-box-column quest-box-background-active" style={width1}>
                                            <a href={this.state.dados.tar_anexo}  target='_blank' className="quest-box-title">Baixar item de missão</a>
                                            <div className="">
                                                <img src={svg6} alt="" />
                                            </div>
                                        </div>
                                        : ""}
                                
                                <div className="quest-box-column quest-box-background-active" style={width2}>
                                    <div className="quest-box-title">Recompensa</div>
                                    <div className="quest-box-text">
                                     {this.state.dados.tar_txt_recompensa}
                                    </div>
                                    <div className="quest-box-info">
                                        <div className="quest-box-row">
                                            <div className="quest-box-column quest-box-background-pattern">
                                                <div className="quest-box-hex">
                                                    <div className="quest-box-hex-label quest-box-hex-label-primary">
                                                        PTS
                                                    </div>
                                                    <div className="quest-box-hex-value">
                                                      {this.state.dados.tar_pontos}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="quest-box-column quest-box-background-pattern">
                                                <div className="quest-box-hex">
                                                    <div className="quest-box-hex-label quest-box-hex-label-gold">
                                                        XP
                                                    </div>
                                                    <div className="quest-box-hex-value">
                                                       {this.state.dados.tar_xp}
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="quest-box-actions">
                         
                                <AcaoMissao dados={this.state.dados}/>
                     
                            
                        </div>
                    </div>
                }
                </main>

                </div>


        );
    }
}



function mapStateToProps(state){

    return {session: state.auth.session,menu: state.configReducer.menu}

}

export default connect(mapStateToProps,{GetTarefa,SetError,GetTipoMidiaPost})(missao_concluir);




// WEBPACK FOOTER //
// ./src/components/aluno/missao/missao_concluir.js